
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g19sMGmFhzsUXZ9JQZKwBoVLlxbpqKV4A3jG_45npuq3pQMeta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexxmrRLNNytCVliywFFeyS4dtZNx191X6ywe13xrjAA_450Meta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchYKWhrzaGTY1fdoPQBBd5mdrzHsYdf_45b8pq13h6H14MIMeta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexplOWO9espH743fsas92JXIQxP9byjbAi8Oht_45gYIIWgMeta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93w3Kir3PZCfd_rVEUY_45FzudDAHoP7bfGIcIt8MfkQHgsMeta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexq_wEhz3kgn0omcqdgb8x8zy_45ygIVqTJcLSryxnCPSy0Meta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_934_45N_45YPSBcHd_45rczXKT0ex5BGIpW9bctl26gt70xDy20Meta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexUY4J4m4eFOQW4r_45uRa8tk0t_45Wiwgn3SWAOtZjorBLisMeta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93liIpyEuGMXcu0LAms_SYgMxlWJmEyM6cbRMWC_45mCf_0Meta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexg0NNCmACQpFTu4HIoY4hnM37rAOjA0_6Yoo0r_45ndwukMeta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexLFvXjOATUNGJPfRR_45kcOOYapEptAxRdRzZY_45obLa3RsMeta } from "/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexq_wEhz3kgn0omcqdgb8x8zy_45ygIVqTJcLSryxnCPSy0Meta || {},
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexUY4J4m4eFOQW4r_45uRa8tk0t_45Wiwgn3SWAOtZjorBLisMeta || {},
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexg0NNCmACQpFTu4HIoY4hnM37rAOjA0_6Yoo0r_45ndwukMeta || {},
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexLFvXjOATUNGJPfRR_45kcOOYapEptAxRdRzZY_45obLa3RsMeta || {},
    component: () => import("/codebuild/output/src2223168078/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]